<article
	class="Alert"
	[class.Alert--with-summary]="!!(dialogData().summary?.sections?.length || dialogData().summary?.rows?.length)"
>
	<mat-dialog-content class="Alert__content">
		<section class="Alert__hero">
			<section class="Alert__icon Alert__icon--{{ dialogData().type }}">
				<ng-container [ngSwitch]="dialogData().type">
					<ng-container *ngSwitchCase="EAlertType.success">
						<app-icon
							[icon]="EIcons.circleCheckSolid"
							[iconSize]="dialogData().summary?.sections?.length || dialogData().summary?.rows?.length ? 'large' : 'extraLarge'"
						/>
					</ng-container>
					<ng-container *ngSwitchCase="EAlertType.error">
						<app-icon [icon]="EIcons.circleXmarkSolid" iconSize="extraLarge" />
					</ng-container>
					<ng-container *ngSwitchCase="EAlertType.warning">
						<app-icon [icon]="EIcons.circleExclamationSolid" iconSize="extraLarge" />
					</ng-container>
					<ng-container *ngSwitchCase="EAlertType.info">
						<app-icon [icon]="EIcons.circleInfoSolid" iconSize="extraLarge" />
					</ng-container>
					<ng-container *ngSwitchDefault>
						<app-icon [icon]="EIcons.circleCheckSolid" iconSize="extraLarge" />
					</ng-container>
				</ng-container>
			</section>
			<p class="Alert__message">
				{{ dialogData().message }}
			</p>
			@if (dialogData().type === EAlertType.error) {
				<p class="Alert__session" data-testid="alert-session">
					Usuario: {{ sessionEmail ?? 'sin sesión' }} · {{ sessionTimestamp }}
				</p>
			}
		</section>
		@if (dialogData().summary?.sections?.length || dialogData().summary?.rows?.length) {
			<section class="Alert__summary">
				<app-summary-panel
					[title]="dialogData().summary!.title"
					[sections]="dialogData().summary!.sections ?? []"
					[rows]="dialogData().summary!.rows ?? []"
					[showTitle]="false"
					density="compact"
				/>
			</section>
		}
	</mat-dialog-content>
	<mat-dialog-actions class="Alert__actions">
		<app-button
			*ngIf="dialogData()?.hasCancelButton"
			isOutline
			color="red"
			(clicked)="onCloseDialog({ isSuccess: false })"
		>
			{{ dialogData().cancelButtonText ? dialogData().cancelButtonText : 'Salir' }}
		</app-button>

		<app-button
			*ngIf="dialogData().hasSuccessButton"
			[color]="dialogData().type === EAlertType.error ? 'red' : 'green'"
			(clicked)="onCloseDialog({ isSuccess: true })"
		>
			{{ dialogData().successButtonText ? dialogData().successButtonText : 'Aceptar' }}
		</app-button>
	</mat-dialog-actions>
</article>
